export default function FooterBotanicalLeft() {
  return (
    <svg
      className="site-footer__botanical site-footer__botanical--left"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1254 1254"
      fill="none"
      aria-hidden="true"
      preserveAspectRatio="xMinYMid meet"
    >
      <g
        className="site-footer__botanical-lines"
        stroke="currentColor"
        strokeWidth="4.35"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {/* caule principal */}
        <path d="M80 1230 C145 1095 210 980 286 858 C350 755 420 660 520 575" />
        <path d="M286 858 C340 760 360 668 354 570" />
        <path d="M520 575 C665 485 825 440 1085 498" />
        <path d="M286 858 C390 772 510 742 628 780 C720 810 785 865 885 850" />

        {/* folha superior */}
        <path
          d="M354 570
             C305 490 288 398 304 304
             C324 190 392 108 488 34
             C490 125 532 188 548 280
             C574 430 520 525 354 570 Z"
        />

        {/* nervura principal folha superior */}
        <path d="M354 570 C386 405 430 220 488 34" />

        {/* nervuras internas - folha superior */}
        <path d="M372 480 C350 430 338 372 340 312" />
        <path d="M392 402 C420 364 446 322 475 270" />
        <path d="M414 320 C438 284 460 244 482 198" />
        <path d="M374 532 C416 504 456 470 498 426" />

        {/* folha do meio */}
        <path
          d="M520 575
             C595 480 690 420 805 392
             C910 368 1008 386 1085 498
             C1002 600 915 665 805 694
             C688 724 594 682 520 575 Z"
        />

        {/* nervura principal folha do meio */}
        <path d="M520 575 C710 550 900 522 1085 498" />

        {/* nervuras internas - folha do meio */}
        <path d="M612 560 C665 520 724 488 790 462" />
        <path d="M715 548 C770 512 830 488 900 470" />
        <path d="M820 532 C900 522 975 514 1050 508" />
        <path d="M605 622 C680 616 755 620 832 633" />
        <path d="M690 652 C760 666 830 664 900 650" />

        {/* folha inferior */}
        <path
          d="M286 858
             C370 750 490 704 620 720
             C720 732 790 810 885 850
             C805 945 720 1012 600 1035
             C468 1060 350 1005 286 858 Z"
        />

        {/* nervura principal folha inferior */}
        <path d="M286 858 C500 842 700 844 885 850" />

        {/* nervuras internas - folha inferior */}
        <path d="M386 830 C448 792 515 765 590 748" />
        <path d="M485 846 C548 812 620 790 700 780" />
        <path d="M590 854 C665 838 740 836 815 842" />
        <path d="M410 895 C480 925 552 944 628 952" />
        <path d="M520 914 C590 944 665 956 738 954" />
      </g>
    </svg>
  );
}